
import * as _moment from 'moment-timezone';

const moment = _moment;

export function checkDST(value: moment.Moment) {
  return value.isAfter(moment('2023-03-11', 'YYYY-MM-DD')) && value.isBefore(moment('2023-11-06', 'YYYY-MM-DD'));
}

export function applyDST(value: moment.Moment) {
  return checkDST(value) ? value.add(1, "hours") : value;
}

export function removeDST(value: moment.Moment) {
  return checkDST(value) ? value.subtract(1, "hours") : value;
}

export function utcToTimezone(utcDate: string, timezone: string): moment.Moment {
  const momentDate = moment(utcDate);

  momentDate.tz(timezone);

  return momentDate;
}

export function timezoneToUtc(tzDate: string): moment.Moment {

  return moment(tzDate).utc();
}

export function checkOrganizationTime(
  orgTimeZone: string, // Pass the timezone string like 'America/New_York'
  reruns?: string[], 
  schedule_time?: string
): boolean {
  // Get the current time in the organization's timezone
  const currentOrgTime = moment().tz(orgTimeZone);

  // Get the hour in the organization's local time
  const currentHour = currentOrgTime.hour();

  // Helper function to convert UTC time to the organization's local time and check if it's between 6 PM and 6 AM
  const isBetween6PMAnd6AM = (utcTime: moment.Moment) => {
    const localTime = utcTime.tz(orgTimeZone); // Convert to the organization's local time using tz
    const hour = localTime.hour();
    const minute = localTime.minute();
    // Time between 6:00 PM (18:00) and midnight (0:00) is night shift
    if (hour > 18 || (hour === 18 && minute >= 0)) {
      return true;
    }
    // Time between midnight (0:00) and 6:00 AM is also night shift
    if (hour < 6) {
      return true;
    }
    return false;
  };

  // Check if the current time is between 6 PM and 6 AM
  const isCurrentTimeBetween = currentHour >= 18 || currentHour < 6;

  // Check if the schedule_time (in UTC) falls between 6 PM and 6 AM in the organization's local time
  const isScheduleTimeBetween = schedule_time ? isBetween6PMAnd6AM(moment(schedule_time)) : false;

  // Check if any rerun (in UTC) falls between 6 PM and 6 AM in the organization's local time
  const isRerunBetween = reruns?.some((rerun) => isBetween6PMAnd6AM(moment(rerun))) ?? false;

  // Return true if the current time, any rerun, or the schedule time falls between 6 PM and 6 AM
  return !!schedule_time ? (isRerunBetween || isScheduleTimeBetween) : !!isCurrentTimeBetween;
}

// Returns the current time in the specified timezone
export function getCurrentTimeOfTimezone(timezone_identifier: string): moment.Moment {
  return moment.tz(moment.utc(), timezone_identifier);
}